.vault {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 800px;

  .description {
    font-size: 14px;
    color: #6c757d;
    line-height: 24px;
    letter-spacing: 0.4px;
    text-align: justify;
  }

  .column {
    gap: 10px;
  }

  .documents {
    display: flex;
    flex-direction: column;
  }
}
